import { useMemo } from 'react';
import useAppStore from '../../../store/appStore';

/**
 * Custom hook for fetching user's properties for use in Leads feature.
 * Provides a lightweight property list for selection dropdowns.
 * Reads from centralized Zustand store (populated by realtimeSubscriptions).
 */
export const useUserProperties = () => {
    const storeProperties = useAppStore((s) => s.ctProperties);
    const loadingProperties = useAppStore((s) => s.loadingStates.properties);

    const loading = loadingProperties || storeProperties === null;

    // Map to lightweight format for dropdown display
    const properties = useMemo(() => {
        if (!storeProperties) return [];
        return storeProperties.map(prop => ({
            id: prop.id,
            displayName: prop.address || 'Untitled Property',
            address: prop.address || '',
            address2: prop.address2 || '',
        }));
    }, [storeProperties]);

    return {
        properties,
        loading,
    };
};

export default useUserProperties;
